module.exports = __webpack_public_path__ + "static/img/nine one.904b246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/nine one.jpg
// module id = qisE
// module chunks = 1